import React from 'react'
import { useTypewriter } from "react-simple-typewriter";
// import Resume from '../assets/myResume.pdf'
import './Home.css'
import { Link } from 'react-scroll'
import { motion } from 'framer-motion';
import ProjectButton from './ProjectButton';
import ResumeBtn from './ResumeBtn';


const Home = () => {
  const [typeEffect] = useTypewriter({
    words: ["FullStack Developer.", "Tech Enthusiast.", "Problem Solver."],
    loop: {},
    typeSpeed: 90,
    deleteSpeed: 20,
  });
  return (
    <div className="">
      <div name='Home' className='h-screen  flex justify-center items-center w-full '>
        <motion.div
          initial={{ opacity: 0, y: 50,scale:0.6 }}
          whileInView={{ opacity: 1, y: 0,scale:1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: false }}
          className=' flex flex-col items-center justify-center h-full px-4 md:flex-row'>
          <div className='flex flex-col justify-center  text-center'>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
              viewport={{ once: false }}

            >
              {/* <h2 className='text-5xl sm:text-7xl font-bold text-white'>I'm</h2> */}
              <h1 className='text-4xl sm:text-5xl font-bold text-orange-600 glow-text py-3'>Utkarsh Shahare</h1>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
              viewport={{ once: false }}

              className='flex my-5 sm:gap-5 justify-center items-center' >

              <div>
                <div className='max-sm:scale-[0.8]'>
                  <Link to="Portfolio" smooth duration={500}>
                    <ProjectButton />
                  </Link>
                </div>
              </div>

              <div className='max-sm:scale-[0.8]'>
                <a href="/myResume.pdf" download="Utkarsh-Shahare">
                  <ResumeBtn />
                </a>
              </div>

            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.7 }}
              viewport={{ once: false }}
            >
              <p className='text-xl md:text-3xl h-10 font-bold text-gray-400 '>{typeEffect}</p>
            </motion.div>

          </div>


        </motion.div>
      </div>
    </div>
  )
};

export default Home;